import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ControlledCollapsibleCard,
  useCollapseControl,
} from '~/components/ui/collapse';
import { Checkbox } from '~/components/ui/forms/Checkbox';
import { TextInput } from '~/components/ui/forms/text-input';
import type { PictureUploadQueueFormValues } from '~/components/upload/file/picture-upload-v4';

export function PictureUploadDefaultValuesForm({
  disabled,
}: {
  disabled: boolean;
}) {
  const form = useFormContext<PictureUploadQueueFormValues>();
  const { setValue } = form;

  const hasAuthor = form.watch('defaultValues.author').trim().length > 0;
  const collapseControl = useCollapseControl(hasAuthor);

  const autofillValues = form.watch('autofillValues');
  const isAutofilling = form.watch('defaultValues.autofill');
  const canAutofill = Boolean(
    autofillValues?.name ||
      autofillValues?.description ||
      autofillValues?.author,
  );

  // If autofill is enabled and the author is set, update the default value
  useEffect(() => {
    if (isAutofilling && autofillValues?.author) {
      setValue('defaultValues.author', autofillValues.author);
    }
  }, [isAutofilling, autofillValues?.author, setValue]);

  return (
    <ControlledCollapsibleCard {...collapseControl} title="Default Values">
      <div className="space-y-2">
        <TextInput
          {...form.register('defaultValues.author')}
          label="Author"
          disabled={disabled || isAutofilling}
        />
        <Checkbox
          {...form.register('defaultValues.autofill')}
          label="Autofill parent values"
          disabled={disabled || !canAutofill}
        />
      </div>
    </ControlledCollapsibleCard>
  );
}
